module.exports = __webpack_public_path__ + "static/img/icon_result_success.0f020c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_result_success.png
// module id = KD9/
// module chunks = 192